import React, { useState } from 'react';

function RejectMemberModal({ isOpen, onClose, onReject, memberName }) {
  const [reason, setReason] = useState('');

  const handleSubmit = e => {
    e.preventDefault();
    onReject(reason);
    setReason('');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-hdlcc-bgWhite text-hdlcc-textDark p-6 rounded shadow-card border border-gray-200 max-w-md w-full">
        <h3 className="text-lg font-bold mb-4 text-hdlcc-textDark">
          Reject Membership Application
        </h3>
        <p className="mb-4 text-hdlcc-textMuted">
          Please provide a reason for rejecting{' '}
          <strong className="text-hdlcc-textDark">{memberName}&apos;s</strong> application:
        </p>

        <form onSubmit={handleSubmit}>
          <textarea
            value={reason}
            onChange={e => setReason(e.target.value)}
            className="w-full p-2 border rounded mb-4 bg-white text-hdlcc-textDark border-gray-300 focus:border-hdlcc-accentRed focus:outline-none transition-colors"
            rows="4"
            required
            placeholder="Enter rejection reason..."
          />

          <div className="flex justify-end space-x-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-hdlcc-bgWhite text-hdlcc-textDark rounded hover:bg-gray-100 border border-gray-300 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-hdlcc-accentRed text-white rounded hover:bg-red-600 transition-colors"
            >
              Reject Application
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default RejectMemberModal;
